import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as styles from './InstagramPreview.scss';
import * as commentStyles from './InstagramComment.scss';
var InstagramPreview = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(InstagramPreview, _Component);

  var _super = _createSuper(InstagramPreview);

  function InstagramPreview() {
    _classCallCheck(this, InstagramPreview);

    return _super.apply(this, arguments);
  }

  _createClass(InstagramPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          image = _this$props.image,
          message = _this$props.message,
          location = _this$props.location,
          numLikes = _this$props.numLikes,
          postTime = _this$props.postTime,
          profileImage = _this$props.profileImage,
          username = _this$props.username,
          videos = _this$props.videos;
      var imageLink = image;
      var videoLink = null;

      if (videos && videos.length > 0) {
        imageLink = null;
        videoLink = this.props.videos[0];
      }

      return /*#__PURE__*/React.createElement("article", {
        className: styles.igArticle
      }, /*#__PURE__*/React.createElement("header", {
        className: styles.igHeader
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.igProfileImageWrap
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.igProfileImage,
        src: profileImage
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.igProfileNameWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.igProfileName
      }, username), /*#__PURE__*/React.createElement("div", {
        className: styles.igPostLocation
      }, location))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.igImageContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.igImageWrap,
        style: videoLink ? {
          paddingBottom: 0
        } : {}
      }, imageLink ? /*#__PURE__*/React.createElement("div", {
        className: styles.igImage,
        style: {
          backgroundImage: "url(".concat(imageLink, ")")
        }
      }) : null, videoLink ? /*#__PURE__*/React.createElement(Video, {
        style: {
          width: '100%',
          height: '100%'
        },
        src: videoLink,
        autoPlay: true,
        loop: true,
        controls: true,
        muted: true
      }) : null))), /*#__PURE__*/React.createElement("div", {
        className: styles.igCommentContainer
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.igLikeSection
      }, numLikes > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.igLikeWrap
      }, numLikes, " like", numLikes !== 1 ? 's' : '')), /*#__PURE__*/React.createElement("div", {
        className: commentStyles.commentWrap,
        style: {
          paddingBottom: 5
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: commentStyles.username
      }, username), /*#__PURE__*/React.createElement("span", {
        className: commentStyles.text
      }, message))), /*#__PURE__*/React.createElement("div", {
        className: styles.igTimeWrap
      }, postTime)));
    }
  }]);

  return InstagramPreview;
}(Component), _defineProperty(_class2, "defaultProps", {
  image: 'http://bit.ly/2rs28ar',
  location: 'Portland, Maine',
  message: '',
  numLikes: 14243,
  postTime: '2 Days Ago',
  profileImage: 'http://bit.ly/2sAwXcG',
  username: 'Likeable Local',
  videos: []
}), _temp)) || _class);
export default InstagramPreview;